import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../Common/Components";
import ImageDisplay from "../../Common/Components/Base/Images/ImageDisplay";
import ImageUploader from "../../Common/Components/Base/Images/ImageUploader";
import PermissionCheck from "../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";

const ImageEditCell = styled.div`
    display: flex;
    justify-content: left;
    align-content: center;
    gap: 20px;
    height: 100%;
`;

export const getColumns = ({ formatMessage, pageRef, setRefreshFlag, customerId, sport }) => [
  {
    title: formatMessage({
      id: "name.local.full",
      defaultMessage: "Local Full Name",
    }),
    dataIndex: "nameFullLocal",
  },
  {
    title: formatMessage({
      id: "images.logo",
      defaultMessage: "Logo",
    }),
    render: (value, row) => {
      const logoImage = row?.images?.find((image) => image?.imageType === "LOGO")?.[0];

      return (
        <ImageEditCell>
          <ImageDisplay
            data={row}
            images={row.images}
            imageType="LOGO"
            pageRef={pageRef}
            setRefreshFlag={setRefreshFlag}
            checkQuality={true}
            permissionKey={PermissionNames.ENTITY}
          />
          <PermissionCheck permissionKeys={[PermissionNames.ENTITY]} permissionOptions={[PermissionOperations.UPDATE]}>
            <ImageUploader
              data={row}
              type={"LOGO"}
              element={"entityId"}
              imageFor={"ENTITY"}
              pageRef={pageRef}
              setRefreshFlag={setRefreshFlag}
              checkQuality={true}
            />
          </PermissionCheck>
        </ImageEditCell>
      );
    },
  },
  {
    title: formatMessage({
      id: "images.team.photo",
      defaultMessage: "Team photo",
    }),
    render: (value, row) => {
      const teamImage = row?.images?.find((image) => image?.imageType === "TEAM_PHOTO")?.[0];

      return (
        <ImageEditCell>
          <ImageDisplay
            data={row}
            images={row.images}
            imageType="TEAM_PHOTO"
            pageRef={pageRef}
            setRefreshFlag={setRefreshFlag}
            permissionKey={PermissionNames.ENTITY}
          />
          <PermissionCheck permissionKeys={[PermissionNames.ENTITY]} permissionOptions={[PermissionOperations.UPDATE]}>
            <ImageUploader
              data={row}
              type={"TEAM_PHOTO"}
              element={"entityId"}
              imageFor={"ENTITY"}
              pageRef={pageRef}
              setRefreshFlag={setRefreshFlag}
            />
          </PermissionCheck>
        </ImageEditCell>
      );
    },
  },
  {
    title: formatMessage({
      id: "images.background",
      defaultMessage: "Background",
    }),
    render: (value, row) => {
      const backgroundImage = row?.images?.find((image) => image?.imageType === "LOGO_BACKGROUND")?.[0];

      return (
        <ImageEditCell>
          <ImageDisplay
            data={row}
            images={row.images}
            imageType="LOGO_BACKGROUND"
            pageRef={pageRef}
            setRefreshFlag={setRefreshFlag}
            permissionKey={PermissionNames.ENTITY}
          />
          <PermissionCheck permissionKeys={[PermissionNames.ENTITY]} permissionOptions={[PermissionOperations.UPDATE]}>
            <ImageUploader
              data={row}
              type={"LOGO_BACKGROUND"}
              element={"entityId"}
              imageFor={"ENTITY"}
              pageRef={pageRef}
              setRefreshFlag={setRefreshFlag}
            />
          </PermissionCheck>
        </ImageEditCell>
      );
    },
  },
  {
    render: (value, row) => (
      <>
        <StyledButton type="text">
          <Link to={`/${customerId}/admin/` + sport + "/" + row.organizationId + "/teams/manage/" + row.entityId}>
            {formatMessage({
              id: "details",
              defaultMessage: "Details",
            })}
          </Link>
        </StyledButton>
      </>
    ),
  },
];
